<template lang="html">
  <div>
    <v-card>
      <v-card-title>{{ $t("forms.title") }}</v-card-title>
      <v-card-text>
        <v-list>
          <v-list-item-group>
            <v-row no-gutters>
              <v-col
                v-for="(form, index) in forms"
                :key="index"
                cols="12"
                md="6"
                lg="4"
              >
                <v-list-item
                  :to="'/news/' + pressNew.id + form.path"
                  class="text-left"
                >
                  <v-list-item-icon>
                    <v-icon v-text="form.icon"></v-icon>
                  </v-list-item-icon>
                  {{ $t(form.title) }}
                </v-list-item>
              </v-col>
            </v-row>
          </v-list-item-group>
        </v-list>
      </v-card-text>
    </v-card>

    <v-card class="mt-4 pa-6">
      <v-row>
        <v-col>
          <v-text-field
            v-model="pressNew.title"
            :label="$t('form.title')"
            readonly
            filled
            outlined
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-text-field
            v-model="pressNew.date"
            :label="$t('form.date')"
            readonly
            filled
            outlined
          ></v-text-field>
        </v-col>
        <v-col>
          <v-text-field
            :value="$t('pressNew.media_types.' + pressNew.media_type)"
            :label="$t('form.pressNew.media_type')"
            readonly
            filled
            outlined
          ></v-text-field>
        </v-col>
        <v-col>
          <v-text-field
            :value="$t('pressNew.scope_types.' + pressNew.scope)"
            :label="$t('form.pressNew.scope')"
            readonly
            filled
            outlined
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-text-field
            v-model="pressNew.media"
            :label="$t('form.pressNew.media')"
            readonly
            filled
            outlined
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-text-field
            v-model="pressNew.uri"
            :label="$t('form.pressNew.uri')"
            readonly
            filled
            outlined
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="text-center mt-6">
          <v-btn
            type="submit"
            class="btn-large-space btn-danger mr-4"
            text
            v-on:click="$router.go(-1)"
            >{{ $t("button.back") }}</v-btn
          >
          <DeleteReasonBtn
            url-objects="news"
            object_type="news"
            :headers="headers"
            :item="pressNew"
          />
        </v-col>
      </v-row>
    </v-card>

    <div class="mt-6 text-center"></div>
  </div>
</template>

<script type="text/javascript">
import DeleteReasonBtn from "../delete_object/DeleteObjectForm";
import pressNew_data from "@/mixins/pressNew_data";
export default {
  mixins: [pressNew_data],
  components: { DeleteReasonBtn },
  data() {
    return {
      forms: [
        {
          icon: "mdi-pencil",
          title: "pressNew.forms.modifyPressNew",
          path: "/forms/modifyPressNewForm"
        }
      ]
    };
  },

  computed: {
    headers() {
      return [
        {
          text: this.$t("form.title"),
          value: "title[gl]"
        }
      ];
    }
  },

  created() {
    this.getPressNewWithBreadCrumb(
      this.$store.state.endpoint + "/news/" + this.$route.params.id
    );
  }
};
</script>
